import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@falcon/env';
import { Newcomer } from '@falcon/app/shared/models/newcomer.model';
import { PageableRequestParamsModel } from '@falcon/app/shared/models/pageable-request-params.model';
import { PageableResponsePayloadModel } from '@falcon/app/shared/models/pageable-response-payload.model';
import { BaseApi } from '../models/base-api';

export const NEWCOMERS_PUBLIC_API_URL = `${environment.publicApiURL}/newcomers`;

@Injectable({ providedIn: 'root' })
export class NewcomerApiService extends BaseApi {
  private http = inject(HttpClient);

  private readonly NEWCOMERS_API_URL = `${environment.apiURL}/newcomers`;

  createNewcomer(payload: Newcomer): Observable<Newcomer> {
    return this.http.post<Newcomer>(
      NEWCOMERS_PUBLIC_API_URL,
      this.mapBodyEmptyStringToNull(payload)
    );
  }

  getNewcomers(
    params: PageableRequestParamsModel & { companyId: string }
  ): Observable<PageableResponsePayloadModel<Newcomer[]>> {
    return this.http.get<PageableResponsePayloadModel<Newcomer[]>>(this.NEWCOMERS_API_URL, {
      params: this.mapParamsToString(params),
    });
  }

  getNewcomer(id: string): Observable<Newcomer> {
    return this.http.get<Newcomer>(`${this.NEWCOMERS_API_URL}/${id}`);
  }

  updateNewcomer(id: string, payload: Newcomer): Observable<Newcomer> {
    return this.http.put<Newcomer>(
      `${this.NEWCOMERS_API_URL}/${id}`,
      this.mapBodyEmptyStringToNull(payload)
    );
  }
}
